import React from 'react';
import OncoreFlexMenuRow from './OncoreFlexMenuRow';
import { NoChildrenProp } from '../common';

const OncoreFlexMenuFill: React.FC<NoChildrenProp> = () => (
  <OncoreFlexMenuRow height="100%" />
);

export default OncoreFlexMenuFill;
